import React, { useEffect, useRef, useState } from 'react';
import Button from '../../../../../../../component/ui/Button';
import InputField from '../../../../../../../component/form/FormInput';
import InputSelect from '../../../../../../../component/inputSelect/InputSelect';
import edit from '../../../../../../../assets/image/edit.svg';
import upload from '../../../../../../../assets/image/upload.svg';
import Modal from '../../../../../../../component/modal/Modal';
import { toast } from 'react-toastify';
import {
	updateOrganizationLogo,
	updatePrimaryContact,
} from '../../../../../../../services/settings/organization';

export default function ProfileForm({
	formData,
	primaryContact,
	primaryContactForm,
	setPrimaryContactForm,
	error,
	isOpenModal,
	setIsOpenModal,
	cityList,
	languageList,
	fiscalYearList,
	dateFormatList,
	dateSeparatorList,
	timeZoneList,
	stateList,
	industryList,
	handleFormData,
	handleAddressFormData,
	getOrganizationProfileDetail,
}) {
	const [disabled, setDisabled] = useState(false);
	const [isUpdate, setIsUpdate] = useState(false);
	const [contactError, setContactError] = useState({});
	const [selectedFile, setSelectedFile] = useState(null);
	const [isDragging, setIsDragging] = useState(false);
	const [uploadedLogo, setUploadedLogo] = useState(null);
	const fileInputRef = useRef(null);
	const [domain, setDomain] = useState('');

	const handleFileSelect = (file) => {
		if (file && file.type.startsWith('image/')) {
			setSelectedFile(file);
			const reader = new FileReader();
			reader.onloadend = () => {
				const imageUrl = reader.result;
				// setPreview(imageUrl);
				setUploadedLogo(imageUrl);
			};
			reader.readAsDataURL(file);
		} else {
			toast.error('Please select a valid image file');
		}
	};

	const handleFileInput = (e) => {
		const file = e.target.files[0];
		handleFileSelect(file);
	};

	const handleDragOver = (e) => {
		e.preventDefault();
		setIsDragging(true);
	};

	const handleDragLeave = (e) => {
		e.preventDefault();
		setIsDragging(false);
	};

	const handleDrop = (e) => {
		if (
			selectedFile === null &&
			(formData.organisation_logo === null || formData.organisation_logo === '')
		) {
			e.preventDefault();
			setIsDragging(false);
			const file = e.dataTransfer.files[0];
			handleFileSelect(file);
		}
	};

	const handleBoxClick = () => {
		if (
			selectedFile === null &&
			(formData.organisation_logo === null || formData.organisation_logo === '')
		) {
			fileInputRef.current.click();
		}
	};
	const handleRemove = (e) => {
		e.stopPropagation();
		setSelectedFile(null);
		// setPreview(null);
		setUploadedLogo(null);
		if (fileInputRef.current) {
			fileInputRef.current.value = '';
		}
		handleFormData('organisation_logo', null);
	};
	const handleUploadLogo = async (e) => {
		e.stopPropagation();
		try {
			const formData = new FormData();
			formData.append('logo', selectedFile);
			const { organisation } = await updateOrganizationLogo(formData);
			console.log(organisation);
			console.log(organisation.organisation_logo);
			toast.success('Organisation logo uploaded successfully');
			handleFormData('organisation_logo', `${organisation?.organisation_logo}`);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};

	const validateEmail = (value) => {
		const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return regex.test(value);
	};

	const handlePrimaryContact = (type, value) => {
		setPrimaryContactForm((prev) => ({
			...prev,
			[type]: value,
		}));
		var newError = { ...contactError };
		if (type === 'name') {
			if (value) {
				if (value === '' || value === null || value === undefined) {
					newError[type] = `Please enter valid contact person in the field`;
				} else {
					delete newError[type];
				}
			} else {
				delete newError[type];
			}
		}
		if (type === 'phone_number') {
			if (value) {
				if (value.length > 10 || value.length < 10) {
					newError[type] = `Please enter valid phone number`;
				} else {
					delete newError[type];
				}
			} else {
				delete newError[type];
			}
		}
		if (type === 'email') {
			if (value) {
				if (validateEmail(value)) {
					delete newError[type];
				} else {
					newError[type] = 'Please enter valid email address';
				}
			} else {
				delete newError[type];
			}
		}
		setContactError(newError);
	};
	const checkValidation = () => {
		var newError = { ...contactError };
		if (
			primaryContact?.name === '' ||
			primaryContact?.name === null ||
			primaryContact?.name === undefined
		) {
			newError.name = 'Please enter contact person in thw field';
		} else {
			delete newError.name;
		}
		if (Object.keys(newError).length > 0) {
			setContactError(newError);
			return true;
		} else {
			return false;
		}
	};

	const handleUpdatePrimaryContact = async () => {
		let isError = checkValidation();
		if (isError) {
			return toast.error('Update primary contact failed ! Please fill required fields.');
		} else {
			try {
				setIsUpdate(true);
				const res = await updatePrimaryContact(primaryContactForm);
				if (res.success === true) {
					setIsOpenModal(false);
					toast.success(res.message);
					getOrganizationProfileDetail();
				} else {
					toast.error(res.message || 'Something went wrong');
				}
			} catch (e) {
				toast.error(e.message);
			} finally {
				setIsUpdate(false);
			}
		}
	};

	useEffect(() => {
		const domainName = new URL(window.location.href).hostname;
		setDomain(domainName);
	}, []);

	return (
		<div>
			<div className="p-4">
				<div className="row align-items-center my-4">
					{/* Upload Section */}
					<div className="col-2 text-sm font-medium">Upload Your Organization Logo</div>
					<div className="col-6 my-2">
						<div
							className={`upload-section text-center p-4 ${
								isDragging ? 'border-primary bg-light' : ' cursor-pointer'
							}`}
							onClick={handleBoxClick}
							onDragOver={handleDragOver}
							onDragLeave={handleDragLeave}
							onDrop={handleDrop}
						>
							<input
								ref={fileInputRef}
								type="file"
								accept="image/*"
								onChange={handleFileInput}
								style={{ display: 'none' }}
							/>
							{(formData.organisation_logo !== '' && formData.organisation_logo !== null) ||
							uploadedLogo ? (
								<div>
									<img
										src={
											formData.organisation_logo !== null && formData.organisation_logo !== ''
												? formData.organisation_logo
												: uploadedLogo
										}
										alt="Organization Logo"
										style={{ maxWidth: '150px', maxHeight: '150px' }}
										className="mb-2"
									/>
									<div className="fw-medium mb-2">{selectedFile?.name}</div>
									<div className="text-muted small mb-2">
										{selectedFile && `${(selectedFile.size / 1024).toFixed(2)} KB`}
									</div>
									<div className="d-flex align-item-center gap-4 justify-content-center">
										<Button
											className="btn btn-outline-danger btn-sm cursor-pointer px-4"
											button="Remove"
											onClick={handleRemove}
										></Button>
										{formData.organisation_logo === null || formData.organisation_logo === '' ? (
											<Button
												className="btn btn-primary btn-sm cursor-pointer px-4"
												button="Upload"
												onClick={handleUploadLogo}
											></Button>
										) : (
											''
										)}
									</div>
								</div>
							) : (
								<div className="p-4">
									<img
										src={upload}
										alt="search-icon"
										width="24"
										height="24"
										className="rounded-circle me-2"
									/>
									<div className="text-sm font-medium my-2">Drag And Drop Here</div>
									<div className="text-sm font-medium my-2">Or Click to Browse</div>
									<div className="fs-5 text-gray">No File Chosen</div>
								</div>
							)}
						</div>
					</div>
				</div>
				<div className="row align-items-center my-1">
					<div className="d-flex col-2 gap-1 align-items-center">
						<div className="text-sm font-medium my-3">Organization Name</div>
						<div className="fs-6 fw-light text-danger">*</div>
					</div>
					<div className="col-6">
						<InputField
							label=""
							placeholder="Organization Name"
							type="text"
							required={true}
							value={formData.organisation_name}
							onChange={(value) => handleFormData('organisation_name', value, true)}
							disabled={disabled}
							error={error?.organisation_name}
						/>
					</div>
				</div>
				<div className="row align-items-center">
					<div className="d-flex col-2 gap-1 align-items-center">
						<div className="text-sm font-medium my-3">Industry</div>
						<div className="fs-6 fw-light text-danger">*</div>
					</div>
					<div className="col-6">
						<InputSelect
							options={industryList}
							label=""
							placeholder="Select Industry"
							error={error?.industry_id}
							returnInputValue={false}
							value={formData.industry_id}
							onChange={(value) => {}}
							onSelect={(options) => handleFormData('industry_id', options.key, true)}
						/>
					</div>
				</div>

				<div className="row align-items-start">
					<div className="col-2 text-sm font-medium my-3">Organization Address</div>
					<div className="col-6 my-2">
						<div>
							<InputField
								label=""
								placeholder="Address Street 1"
								type="text"
								required={false}
								value={formData?.address?.street_1}
								onChange={(value) => handleAddressFormData('street_1', value)}
								disabled={disabled}
								error={error?.street_1}
							/>
						</div>
						<div className="my-3">
							<InputField
								label=""
								placeholder="Address Street 2"
								type="text"
								required={false}
								value={formData.address?.street_2}
								onChange={(value) => handleAddressFormData('street_2', value)}
								disabled={disabled}
								error={error?.street_2}
							/>
						</div>
						<div className="row align-items-start">
							<div className="col-6">
								<InputSelect
									options={stateList}
									label=""
									placeholder="Select State"
									error={error?.state_id}
									returnInputValue={false}
									value={formData.address?.state_id}
									onChange={(value) => {}}
									onSelect={(options) => {
										handleAddressFormData('state_id', options.key);
									}}
								/>
							</div>
							<div className="col-6 my-2">
								<InputField
									label=""
									placeholder="Zip code"
									type="text"
									required={false}
									value={formData.address?.postal_code}
									onChange={(value) => handleAddressFormData('postal_code', value)}
									disabled={disabled}
									error={error?.postal_code}
								/>
							</div>
						</div>
						<div className="row align-items-start">
							<div className="col-6">
								<InputSelect
									options={cityList}
									label=""
									placeholder="Select City"
									error={error?.city_id}
									returnInputValue={false}
									value={formData.address?.city_id}
									onChange={(value) => {}}
									onSelect={(options) => handleAddressFormData('city_id', options.key)}
								/>
							</div>
							<div className="col-6 my-2">
								<InputField
									label=""
									placeholder="Mobile no"
									type="text"
									required={false}
									value={formData.address.phone_number}
									onChange={(valueData) => {
										var value = valueData?.replace(/[^0-9]/g, '');
										handleAddressFormData('phone_number', value, true);
									}}
									disabled={disabled}
									error={error?.phone_number}
								/>
							</div>
						</div>
						<div className="my-1">
							<div className="input-group mb-3">
								<div className="input-group-append">
									<span
										className="input-group-text font-medium"
										style={{
											minHeight: '3.6rem',
											fontSize: '1.4rem',
											marginLeft: '.1rem',
											minWidth: '5rem',
											justifyContent: 'center',
											color: 'var(--brand-color)',
											borderRadius: ' 8px 0 0 8px',
										}}
									>
										{`${domain}/user/`}
									</span>
								</div>
								<input
									style={{
										borderRadius: '8px',
										borderTopLeftRadius: '0px',
										borderBottomLeftRadius: '0px',
										border: '1px solid rgba(85, 91, 103, 0.15)',
										backgroundColor: '#FCFCFC',
										padding: '8px',
										borderLeft: '0',
									}}
									type="text"
									className="form-control"
									id="inlineFormInputGroup"
									placeholder="thewaltdesinycompany"
									onChange={(e) => handleFormData('domain', e?.target?.value)}
									value={formData.domain}
									label=""
									name={'sub_domain'}
									error={error?.domain}
								/>
							</div>

							{/* <InputField
								label=""
								placeholder="domain"
								type="text"
								required={true}
								value={formData.domain}
								onChange={(value) => handleFormData('domain', value)}
								disabled={disabled}
								error={error?.domain}
							/> */}
						</div>
					</div>
				</div>
				<div className="d-flex align-items-center">
					<div className="col-2 text-sm font-medium">Primary Contact</div>
					<div className="col-6 my-2">
						<div className="d-flex profile-contact py-3">
							<div className="col-8 text-center py-3">
								<div className="fs-5 fw-semibold text-dark">{primaryContact?.name || ''}</div>
								<div className="fs-6 fw-light text-dark">
									{primaryContact.email && `(${primaryContact.email})`}
								</div>
							</div>
							<p style={{ borderRight: '1px solid #000', margin: '0px' }}></p>
							<div className="col-4 text-center py-3">
								<div className="fs-5 fw-semibold text-dark">
									{primaryContact.phone_number && 'Phone'}
								</div>
								<div className="fs-6 fw-light text-dark">{primaryContact.phone_number}</div>
							</div>
						</div>
					</div>
					<div>
						<img
							src={edit}
							alt="search-icon"
							width="24"
							height="24"
							onClick={() => {
								setContactError({});
								setPrimaryContactForm(primaryContact);
								setIsOpenModal(true);
							}}
							className="m-2 cursor-pointer"
						/>
					</div>
				</div>
				<div className="row align-items-center">
					<div className="d-flex col-2 gap-1 align-items-center">
						<div className="text-sm font-medium my-3">Fiscal Year</div>
						<div className="fs-6 fw-light text-danger">*</div>
					</div>
					<div className="col-6">
						<InputSelect
							options={fiscalYearList}
							label=""
							placeholder="Select Fiscal Year"
							error={error?.fiscal_year}
							returnInputValue={false}
							value={formData.fiscal_year}
							disabled={true}
							onChange={(value) => {}}
							onSelect={(options) => handleFormData('fiscal_year', options.value)}
						/>
					</div>
				</div>
				<div className="row align-items-center">
					<div className="col-2 text-sm font-medium">Language</div>
					<div className="col-6">
						<InputSelect
							options={languageList}
							label=""
							placeholder="Select Language"
							error={error?.language}
							returnInputValue={false}
							value={formData.language}
							disabled={true}
							onChange={(value) => {}}
							onSelect={(options) => handleFormData('language', options.value)}
						/>
					</div>
				</div>
				<div className="row align-items-center">
					<div className="col-2 text-sm font-medium">Time Zone</div>
					<div className="col-6">
						<InputSelect
							options={timeZoneList}
							label=""
							placeholder="Select Time Zone"
							error={error?.time_zone}
							returnInputValue={false}
							value={formData.time_zone}
							disabled={true}
							onChange={(value) => {}}
							onSelect={(options) => handleFormData('time_zone', options.value)}
						/>
					</div>
				</div>
				<div className="row align-items-center">
					<div className="col-2 text-sm font-medium">Date Format</div>
					<div className="col-5">
						<InputSelect
							options={dateFormatList}
							label=""
							placeholder="Select Date Format"
							error={error?.date_format}
							returnInputValue={false}
							disabled={false}
							value={formData.date_format}
							onChange={(value) => {}}
							onSelect={(options) => handleFormData('date_format', options.value)}
						/>
					</div>
					<div className="col-1">
						<InputSelect
							options={dateSeparatorList}
							label=""
							placeholder="Select Date Format"
							error={error?.date_separator}
							returnInputValue={false}
							disabled={false}
							value={formData.date_separator}
							onChange={(value) => {}}
							onSelect={(options) => handleFormData('date_separator', options.value)}
						/>
					</div>
				</div>
			</div>
			{isOpenModal && (
				<Modal
					className="profile_model"
					title={`Edit Primary Contact`}
					isOpen={isOpenModal}
					onClose={() => {
						setIsOpenModal(false);
					}}
					cancelButton={() => {
						setIsOpenModal(false);
					}}
				>
					<div>
						<div className="my-1">
							<InputField
								label="Contact Person"
								placeholder="Contact Person"
								type="text"
								required={true}
								autoFocus={true}
								value={primaryContactForm.name}
								onChange={(value) => handlePrimaryContact('name', value)}
								disabled={disabled}
								error={contactError?.name}
							/>
						</div>
						<div className="my-1">
							<InputField
								label="Email"
								placeholder="Email Address"
								type="text"
								required={true}
								value={primaryContactForm.email}
								onChange={(value) => handlePrimaryContact('email', value)}
								disabled={true}
								error={contactError?.email}
							/>
						</div>
						<div className="my-1">
							<InputField
								label="Phone"
								placeholder="Phone"
								type="text"
								required={false}
								value={primaryContactForm.phone_number}
								onChange={(valueData) => {
									var value = valueData?.replace(/[^0-9]/g, '');
									handlePrimaryContact('phone_number', value);
								}}
								disabled={disabled}
								error={contactError?.phone_number}
							/>
						</div>
					</div>

					<div className="d-flex align-items-center justify-content-end gap-4 mt-4">
						<Button
							type="button"
							button={`Save`}
							disabled={isUpdate}
							loader={isUpdate}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => handleUpdatePrimaryContact()}
						/>
						<Button
							type="button"
							button={`Cancel`}
							className="mt-0 px-4 btn-gray relative"
							onClick={() => setIsOpenModal(false)}
						/>
					</div>
				</Modal>
			)}
		</div>
	);
}
